export const SkillsData = [
  {
    type: "Web-Development",
    list: [
      {
        name: "HTML",
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: "CSS",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      {
        name: "Bootstrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>,
      },
      {
        name: "Material UI",
        icon: <i class="devicon-materialui-plain colored"></i>,
      },
      {
        name: "Typescript",
        icon: <i class="devicon-typescript-plain colored"></i>,
      },
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: "NextJS",
        icon: <i class="devicon-nextjs-original colored"></i>,
      },

      {
        name: "Rest API",
        icon: <i class="devicon-python-plain colored"></i>,
      },
      {
        name: "Github",
        icon: <i class="devicon-github-original colored"></i>,
      },
    ],
  },
];
